import { useRoute } from "vue-router"
import { EUROPE, SAUDI_ARABIA, USA } from "@/core/constants"

export default function dataRegionHelperFunction() {
    const route = useRoute()
    const getRouteRegionParam = () => {
        let regionParam = ""
        regionParam =
            route.query.region === "eu" || route.query.region === EUROPE
                ? EUROPE
                : route.query.region === "sa" ||
                  route.query.region === SAUDI_ARABIA
                ? SAUDI_ARABIA
                : USA
        return regionParam
    }
    const getRegion = (selectedDataRegion: string) => {
        const regionMap: Record<string, string> = {
            [EUROPE]: "eu",
            [SAUDI_ARABIA]: "sa",
            [USA]: "usa",
        }
        return regionMap[selectedDataRegion] ?? "usa"
    }
    return {
        getRouteRegionParam,
        getRegion,
    }
}
